import isEmpty from 'lodash/isEmpty';
import reduce from 'lodash/reduce';
import reject from 'lodash/reject';
import { DEALER_LOCATOR_ENDPOINT } from '@yme/common/endpoints';
import { Network } from '@yme/services/network';
const query = `
  query GetCategoriesByCountry ($country: String!, $limit: Int, $offset: Int) {
    GetCategoriesByCountry (country: $country, limit: $limit, offset: $offset) {
      categories {
        categoryId
        categoryName
        services {
            serviceId
            serviceName
        }
      },
      language
    }
  }
`;
export const getCategoriesByCountry = async ({ country, limit, offset, language, }) => {
    const response = await Network.post(DEALER_LOCATOR_ENDPOINT, {
        query,
        variables: {
            country,
            limit,
            offset,
        },
    });
    const responseCategoryByCountry = response.data.data.GetCategoriesByCountry;
    const languageCategories = language
        ? responseCategoryByCountry.filter((item) => item.language?.toLowerCase() === language.toLowerCase())
        : [];
    const categoriesByCountry = languageCategories.length
        ? languageCategories
        : responseCategoryByCountry;
    const result = reduce(categoriesByCountry, (acc, categoryGroup) => {
        const nonEmptyCategories = reject(categoryGroup.categories, ({ services }) => isEmpty(services));
        return [...acc, ...nonEmptyCategories];
    }, []);
    return result;
};
